import React from 'react';
import Img from 'gatsby-image';
import injectSheet from 'react-jss';

import { layoutMaxWidth } from '../layouts/const.js';

const BackgroundImageSection = ({ classes, children, sizesBackground }) => {
    return (
        <div className={classes.container}>
            <section className={classes.section}>
                <div className={classes.contents}>
                    {children}
                </div>
            </section>
            <Img
                className={classes.background}
                sizes={sizesBackground}
                />
        </div>
    );
};

const defaultHeight = '28rem';
const tallerHeight = '39rem';
const defaultMobileHeight = '28rem'; //'30.2rem';
const tallerMobileHeight = '39rem'; //'56rem';

const styles = {
    container: {
        width: '100%',
        height: ({ taller }) => taller ? tallerHeight : defaultHeight,
        backgroundColor: '#262626',
        boxShadow: ({ boxShadow = '0 10px 10px #C0C0C0'}) => boxShadow,
        '@media only screen and (max-width: 768px)': {
            height: ({ taller }) => taller ? tallerMobileHeight : defaultMobileHeight
        }
    },
    section: {
        position: 'absolute',
        width: '100%',
        zIndex: 1
    },
    contents: {
        width: '90%',
        maxWidth: ({ maxWidth = layoutMaxWidth }) => maxWidth,
        height: ({ taller }) => taller ? tallerHeight : defaultHeight,
        margin: ({ margin = '0 auto'}) => margin,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: ({ justifyContent = 'flex-end' }) => justifyContent,
        '& h1': {
            fontFamily: [ 'Noto Sans Regular', 'sans-serif' ],
            fontSize: '2.35rem',
            fontWeight: 'normal',
            color: '#F4FFF6',
            textAlign: 'center',
            marginBottom: ({ taller }) => taller ? '1em' : '0.5em'
        },
        '& p': {
            fontFamily: [ 'Noto Sans Light', 'sans-serif' ],
            fontSize: '1.06rem',
            textAlign: 'center',
            lineHeight: 1.3,
            color: '#F9FFFE',
            marginBottom: ({taller}) => taller ? '4rem' : '7rem'
        },
        '& button': {
            fontFamily: [ 'Noto Sans Regular', 'sans-serif' ],
            fontSize: '0.71rem',
            color: '#F9FFFE',
            letterSpacing: '0.12em',
            cursor: 'pointer'
        },
        '& a': {
            fontFamily: [ 'Noto Sans Light', 'sans-serif' ],
            fontSize: '1.52rem',
            color: 'PaleGreen'
        },
        '@media only screen and (max-width: 768px)': {
            height: ({ taller }) => taller ? tallerMobileHeight : defaultMobileHeight
        }
    },
    background: {
        height: ({ taller }) => taller ? tallerHeight : defaultHeight,
        overflow: 'hidden',
        '@media only screen and (max-width: 768px)': {
            height: ({ taller }) => taller ? tallerMobileHeight : defaultMobileHeight
        }
    }
};

export default injectSheet(styles)(BackgroundImageSection);



// WEBPACK FOOTER //
// ./src/components/BackgroundImageSection.js